export default {
  SET_ENTITY (state, {entity, data}) {
    state[entity] = data
  },
  SET_LOOKUPS_FROM_DETAILS (state, lookups) {
    state.lookupsFromDetailsSearch = lookups
  },
  SET_LOOKUP_DETAILS_TOGGLE (state, bool) {
    state.lookupDetailsToggle = bool
  },
  SET_VENDOR_ZONE_LOCATIONS (state, vendorZoneLocations) {
    state.vendorZoneLocations = vendorZoneLocations
  },
  SET_VENDOR_ZONE_LOCATIONS_COUNT (state, count) {
    state.vendorZoneLocationsCount = count
  },
  SET_PORT_AREA_TO_PORTS (state, portAreaToPorts) {
    state.portAreaToPorts = portAreaToPorts
  },
  SET_POINT_TO_POINT_TO_PORTS (state, pointToPortToPorts) {
    state.pointToPortToPorts = pointToPortToPorts
  },
  SET_PARENT_DESCRIPTOR (state, id) {
    state['spreadsheet-descriptor-parent'] = id
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/store/mutations.js